import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {routeList} from './routes';

@NgModule({
  imports: [RouterModule.forRoot(routeList, {onSameUrlNavigation: "reload"})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
